<template>
  <div>
    <select-base
      v-model="valueInner"
      :disabled="disabled"
      :multiple="multiple"
      :label="label"
      :label-select="'nome'"
      :carregar="carregarServicos"
      :filtro-adicional="filtroAdicional"
      :invalido="invalido"
      :clearable="clearable"
      @input="enviarParaPai"
    />
  </div>
</template>

<script>
import api from '@/app-modulo/comuns/servico/shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'ServicoSelect',
  components: {
    SelectBase: () => import('@/shared/components/select-base/SelectBase.vue'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    invalido: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Object, Array],
      default: () => { },
    },
    label: {
      type: String,
      default: 'Serviço',
    },
    filtroAdicional: {
      type: Function,
      default: () => null,
    },
    filtroPorAtividadeTributacao: {
      type: Boolean,
      default: false,
    },
    tributacaoId: {
      type: Number,
      default: 0,
    },
    atividadeId: {
      type: Number,
      default: 0,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value_: {},
      filtros: [
        {
          coluna: 'Nome',
          valor: '',
        },
      ],
    }
  },
  computed: {
    valueInner: {
      set(value) {
        // eslint-disable-next-line no-underscore-dangle
        this.value_ = value
      },
      get() {
        // eslint-disable-next-line no-underscore-dangle
        return this.value_
      },
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
      }
    },
  },
  created() {
    this.valueInner = this.value
  },
  methods: {
    carregarServicos(filtros) {
      if (this.filtroPorAtividadeTributacao) {
        return api.getServicosTributacaoAtividade(this.tributacaoId, this.atividadeId, filtros)
      }
      return api.getServicosResumidos(filtros)
    },
    enviarParaPai() {
      this.$emit('input', this.valueInner)
    },
  },
}
</script>
